import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, thriweMarketPlaceUrl } from '../../../../Containers/Config/index.js';
import { COMPLETE_BOOKING_V2, COMPLETE_BOOKING_V2_SUCCESS, COMPLETE_BOOKING_V2_ERROR } from '../../actionType.js';
import apiCall from '../../apiCall.js';
import cogoToast from 'cogo-toast';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* CompleteBookingV2({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweMarketPlaceUrl}/v1/admin/process-booking/${payload?.data?.booking_id}`,
      method: 'PUT',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: COMPLETE_BOOKING_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: COMPLETE_BOOKING_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: COMPLETE_BOOKING_V2_ERROR, payload: error });
  }
}

export function* watchCompleteBookingV2() {
  yield takeEvery(COMPLETE_BOOKING_V2, CompleteBookingV2);
}

function* completeBookingV2Saga() {
  yield all([fork(watchCompleteBookingV2)]);
}

export default completeBookingV2Saga;
